import { Component, OnInit } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService } from '../../services/authentication.service';
import { ConfigService } from '../../services/config.service';
import { DepotLocation } from '../../../models/location';
import { MatFormField } from '@angular/material/form-field';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-set-location-dialog',
  templateUrl: './set-location-dialog.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatFormField,
    MatSelectModule,
    MatDialogModule,
    FormsModule
  ]
})
export class SetLocationDialogComponent implements OnInit {
  locations = [];
  selectedLocation: DepotLocation;
  mustSetLocation: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<SetLocationDialogComponent>,
    private configService: ConfigService
  ) {}

  ngOnInit() {
    this.configService.currentLocation.subscribe((location) => {
      if (!location) {
        return;
      }
      this.checkButtonDisabled();
    });

    this.configService.locations.subscribe((locations) => {
      if (!locations) {
        return;
      }
      this.locations = locations;
      this.checkButtonDisabled();
    });
  }

  checkButtonDisabled() {
    this.mustSetLocation =
      !this.selectedLocation ||
      (this.selectedLocation.id === 0 && this.locations.length > 0);
  }

  updateLocation() {
    this.configService.setCurrentLocation(this.selectedLocation);
    this.dialogRef.close();
  }
}
